import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Box,
  Typography,
  Paper,
} from "@mui/material";

/**
 * Modal for previewing mapping results
 */
const PreviewModal = ({ open, onClose, modalState }) => {
  const { title, originalData, mappedData, intermediateData } = modalState;

  return (
    <Dialog open={open} onClose={onClose} maxWidth="lg" fullWidth>
      <DialogTitle>{title}</DialogTitle>
      <DialogContent>
        <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
          {originalData && (
            <Box>
              <Typography variant="h6" gutterBottom>
                Original Data:
              </Typography>
              <Paper variant="outlined" sx={{ p: 2, maxHeight: 200, overflow: "auto" }}>
                <Typography component="pre" sx={{ whiteSpace: "pre-wrap", fontSize: "12px" }}>
                  {JSON.stringify(originalData, null, 2)}
                </Typography>
              </Paper>
            </Box>
          )}

          {intermediateData && (
            <Box>
              <Typography variant="h6" gutterBottom>
                After Ingestion Mapping:
              </Typography>
              <Paper variant="outlined" sx={{ p: 2, maxHeight: 200, overflow: "auto" }}>
                <Typography component="pre" sx={{ whiteSpace: "pre-wrap", fontSize: "12px" }}>
                  {JSON.stringify(intermediateData, null, 2)}
                </Typography>
              </Paper>
            </Box>
          )}

          {mappedData && (
            <Box>
              <Typography variant="h6" gutterBottom>
                {intermediateData ? "Final Prospect Data:" : "Mapped Data:"}
              </Typography>
              <Paper variant="outlined" sx={{ p: 2, maxHeight: 200, overflow: "auto" }}>
                <Typography component="pre" sx={{ whiteSpace: "pre-wrap", fontSize: "12px" }}>
                  {JSON.stringify(mappedData, null, 2)}
                </Typography>
              </Paper>
            </Box>
          )}
        </Box>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Close</Button>
      </DialogActions>
    </Dialog>
  );
};

export default PreviewModal;
